import React, {useState} from "react";
import {dessertsCard} from "../../content/food";

const Dessert = ({onglet}) => {

    const [desserts] = useState(dessertsCard);

    return (
        <div className={onglet === 4 ? "visible" : "hidden"}>
            <section className='mx-auto '>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-5 md:mx-20 xl:mx-48'>
                    {desserts?.map(dessert =>
                        <div key={dessert.id} className='p-2 '>
                            <div className='grid grid-cols-3 shadow-lg bg-white rounded-lg h-32 xl:h-44'>
                                <div className='col-span-1'>
                                    <img
                                        alt={dessert.name}
                                        className='rounded-lg rounded-r-none object-center w-52 h-32 xl:h-44 object-cover'
                                        src={dessert.picture}
                                    />
                                </div>

                                <div
                                    className={dessert.description ? 'col-span-2 grid grid-rows-3 p-3 shadow-lg shadow-none  bg-white bg-transparent rounded-lg rounded-l-none' :
                                        'col-span-2 grid grid-rows-2 p-3 shadow-lg shadow-none  bg-white bg-transparent rounded-lg rounded-l-none '}>
                                    <h2 className=' tracking-tight text-base font-semibold uppercase text-secondary my-0.5'>
                                        {dessert.name}
                                    </h2>
                                    {dessert.description && <p className='text-gray-700 text-xs leading-snug'>
                                        {dessert.description}
                                    </p>}
                                    <div className=''>
                  <span className='mt-1 text-sm font-semibold text-gray-800 block '>
                      {dessert.price}€
                  </span>
                                    </div>
                                </div>
                            </div>
                        </div>)}

                </div>
            </section>
        </div>
    );
};

export default Dessert;
